import React from 'react';
import PaperPlane from '../SVGs/PaperPlane';
const NoPackages = ({isCurrentCycle=false}) => {
  return (
    <div className="NoDataDiv">
      <PaperPlane />
      <p className='NoDataHeading'>{'לא קיימים נתונים להצגה במחזור החיוב ה'+(isCurrentCycle ? 'נוכחי' : 'קודם')}</p>
    </div>
  );
};

export default NoPackages;
